<template>
	<a-drawer :title="title" :width="1600" :closable="false" :visible="visible" @close="onClose" :destroyOnClose="true">
		<a-form :form="form">
			<a-row class="titleBox">
				<a-col :span="2" class="boxLabel">
					姓名:
				</a-col>
				<a-col :span="4">
					{{user.realname}}
				</a-col>
				<a-col :span="2"  class="boxLabel">
					部门:
				</a-col>
				<a-col :span="4">
					{{user.deptName}}
				</a-col>
				<a-col :span="2"  class="boxLabel">
					职位:
				</a-col>
				<a-col :span="4">
					{{user.jobTitle_text}}
				</a-col>
				<a-col :span="2" class="boxLabel">
					汇报时间:
				</a-col>
				<a-col :span="4" style="height: 65px;">
					<a-form-item style="height: 65px; display: flex; align-items: center" >
						<a-date-picker :disabled ="disabled" v-decorator="['reportTime',{rules: [{ required: true, message: '请选择汇报时间!'}]}]" placeholder="请选择汇报时间" />
					</a-form-item>
				</a-col>
			</a-row>
			<a-row class="task">
				<a-col :span="2" class="boxLabelOne firstLevelMeter">
					任务
				</a-col>
				<a-col :span="10" class="firstLevelMeter">
					本月完成事项
				</a-col>
				<a-col :span="2" class="boxLabel firstLevelMeter">
					任务
				</a-col>
				<a-col :span="10" class="firstLevelMeter">
					下月工作待完成事项
				</a-col>
			</a-row>
			<a-row class="taskItemBox" v-for="(k, index) in workTaskDataArr" :key="'task'+index">
				<a-col :span="2" class="boxLabelOne">
					{{index+1}}
				</a-col>
				<a-col :span="10">
					<a-form-item>
						<a-textarea :disabled ="disabled" v-model="workTaskDataArr[index].currentMonthlyTask" allowClear  placeholder="请输入本月完成事项" :autosize="{ minRows: 2, maxRows: 2 }" style="width: 100%"/>
					</a-form-item>
				</a-col>
				<a-col :span="2" class="boxLabel">
					{{index+1}}
				</a-col>
				<a-col :span="10">
					<a-row style="width: 100%;">
						<a-col :span="22">
							<a-form-item>
								<a-textarea :disabled ="disabled" v-model="workTaskDataArr[index].nextMonthlyTask" allowClear  placeholder="请输入下月工作待完成事项" :autosize="{ minRows: 2, maxRows: 2 }" style="width:100%"/>
							</a-form-item>
						</a-col>
						<a-col v-show="isEditShow" :span="2" style="text-align:center;height: 85px; line-height: 85px;border-left: 1px #ccc solid">
							<a-icon v-if="workTaskDataArr.length > 1 && !disabled" class="dynamic-delete-button" type="minus-circle-o" :disabled="workTaskDataArr.length === 1" @click="() => removeWorkTask(index)"
							/>
						</a-col>
					</a-row>
				</a-col>
			</a-row>
			<a-row class="btnBox" type="flex" justify="center" align="middle" v-if="!disabled">
				<a-col :span="16">
					<a-button type="dashed" style="width: 100%" @click="addWorkTask">
						<a-icon type="plus" /> 添加任务
					</a-button>
				</a-col>
			</a-row>
			<a-row class="recordTitleBox">
				<a-col :span="12" class="boxLabelOne firstLevelMeter">
					本月工作记录
				</a-col>
				<a-col :span="12" class="firstLevelMeter">
					本月工作中存在问题以及建议解决方法
				</a-col>
			</a-row>
			<a-row class="recordSubTitleBox">
				<a-col :span="12" class="boxLabelOne">
					<a-row>
						<a-col :span="4" class="boxLabelOne secondaryHeader">具体时间</a-col>
						<a-col :span="16" class="secondaryHeader">工作内容记录</a-col>
						<a-col v-show="isEditShow" :span="4" class="secondaryHeader">操作</a-col>
					</a-row>
				</a-col>
				<a-col :span="12">
					<a-row>
						<a-col :span="3" class="boxLabelOne secondaryHeader">编号</a-col>
						<a-col :span="9" class="boxLabelOne secondaryHeader">存在问题</a-col>
						<a-col :span="9" class="boxLabelOne secondaryHeader">提议解决办法</a-col>
						<a-col :span="3" class="secondaryHeader">是/否解决</a-col>
<!--						<a-col :span="2">操作</a-col>-->
					</a-row>
				</a-col>
			</a-row>
			<a-row class="recordItemBox" v-for="(k, index) in workRecordDataArr" :key="'record'+index">
				<a-col :span="12" class="boxLabelOne">
					<a-row>
						<a-col :span="4" class="boxLabelOne">
							<a-row>
								<a-col :span="24" :style="{'height' : 51*k.workRecordList.length + 'px'}" style="font-weight:bold">
									第{{index+1}}周
								</a-col>
							</a-row>
<!--							<a-row>-->
<!--								<a-col :span="8" class="boxLabelOne" :style="{'height' : 51*k.workRecordList.length + 'px'}">-->
<!--									第{{index+1}}周-->
<!--								</a-col>-->
<!--								<a-col :span="16" :style="{'height' : 51*k.workRecordList.length + 'px'}">-->
<!--									<a-range-picker format="MM-DD" v-model="k.time" :disabled ="disabled"/>-->
<!--								</a-col>-->
<!--							</a-row>-->
						</a-col>
						<a-col v-if="isEditShow==true" :span="16" class="boxLabelOne" :style="{'height' : 51*k.workRecordList.length + 'px'}">
							<a-row >
								<a-col :span="24" v-for="(i,index2) in k.workRecordList" :key="'recordText'+(index2+1)" class="recordText">
									<a-textarea :disabled ="disabled" v-model="k.workRecordList[index2]" allowClear  placeholder="请输入工作内容" :autosize="{ minRows: 2, maxRows: 2 }" style="width:100%"/>
								</a-col>
							</a-row>
						</a-col>
						<a-col v-if="isEditShow==false" :span="20" class="boxLabelOne" :style="{'height' : 51*k.workRecordList.length + 'px'}">
							<a-row >
								<a-col :span="24" v-for="(i,index2) in k.workRecordList" :key="'recordText'+(index2+1)" class="recordText">
									<a-textarea :disabled ="disabled" v-model="k.workRecordList[index2]" allowClear  placeholder="请输入工作内容" :autosize="{ minRows: 2, maxRows: 2 }" style="width:100%"/>
								</a-col>
							</a-row>
						</a-col>
						<a-col v-show="isEditShow" :span="2" class="boxLabelOne" :style="{'height' : 51*k.workRecordList.length + 'px'}">
							<a-row>
								<a-col :span="24" :disabled ="disabled" v-for="(i,index2) in k.workRecordList" :key="'recordBtn'+(index2+1)" style="height: 51px;"  class="recordText">
									<a-icon
										v-if="k.workRecordList.length > 2 && !disabled"
										class="dynamic-delete-button"
										type="minus-circle-o"
										style="cursor: pointer"
										:disabled="k.workRecordList.length === 2"
										@click="() => removeRecordText(index , index2)"
									/>
								</a-col>
							</a-row>
						</a-col>
						<a-col v-show="isEditShow" :span="2" :style="{'height' : 51*k.workRecordList.length + 'px'}">
							<a-icon
								v-if="!disabled"
								class="dynamic-delete-button"
								type="edit"
								@click="() => addRecordText(index)"
							/>
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="12">
					<a-row>
						<a-col :span="3" class="boxLabelOne" :style="{'height' : 51*k.workRecordList.length + 'px'}">{{index+1}}</a-col>
						<a-col :span="9" class="boxLabelOne" :style="{'height' : 51*k.workRecordList.length + 'px'}">
							<a-textarea :disabled ="disabled" v-model="k.problem" allowClear  placeholder="请输入存在问题" :autosize="{ minRows: 4, maxRows: 4 }" style="width:100%"/>
						</a-col>
						<a-col :span="9" class="boxLabelOne" :style="{'height' : 51*k.workRecordList.length + 'px'}">
							<a-textarea :disabled ="disabled" v-model="k.solution" allowClear  placeholder="请输入解决方案" :autosize="{ minRows: 4, maxRows: 4 }" style="width:100%"/>
						</a-col>
						<a-col :span="3"  :style="{'height' : 51*k.workRecordList.length + 'px'}">
							<a-switch v-model="k.solve" :disabled ="disabled"/>
						</a-col>
<!--						<a-col :span="2" :style="{'height' : 51*k.workRecordList.length + 'px'}">-->
<!--							<a-icon-->
<!--								v-if="workRecordDataArr.length > 1 && !disabled"-->
<!--								class="dynamic-delete-button"-->
<!--								type="minus-circle-o"-->
<!--								:disabled="workRecordDataArr.length === 1"-->
<!--								@click="() => removeWorkRecord(k.id)"-->
<!--							/>-->
<!--						</a-col>-->
					</a-row>
				</a-col>
				<a-col :span="2">
				</a-col>
			</a-row>

			<a-row class="btnBox" type="flex" justify="center" align="middle" v-if="workRecordDataArr.length<5 && !disabled">
				<a-col :span="16">
					<a-button type="dashed" style="width: 100%" @click="addWorkRecord">
						<a-icon type="plus" /> 添加工作记录
					</a-button>
				</a-col>
			</a-row>
			<a-row class="workSummaryTitleBox">
				<a-col :span="24" class="firstLevelMeter">
					本月工作总结
				</a-col>
			</a-row>
			<a-row class="workSummaryBox">
				<a-col :span="24">
					<a-form-item>
						<a-textarea :disabled ="disabled" v-model="workSummary" allowClear  placeholder="请输入工作总结" :autosize="{ minRows: 4, maxRows: 5 }" style="width:100%"/>
					</a-form-item>
				</a-col>
			</a-row>

			<a-row class="commentTitleBox" v-if="reading || status ==='5'">
				<a-col :span="24" class="firstLevelMeter">
					批阅评语
				</a-col>
			</a-row>
			<a-row class="commentBox" v-if="reading || status ==='5'">
				<a-col :span="24">
					<a-form-item>
						<a-textarea v-model="comment" allowClear :disabled ="!reading" placeholder="请输入批阅评语" :autosize="{ minRows: 4, maxRows: 5 }" style="width:100%"/>
					</a-form-item>
				</a-col>
			</a-row>
			<div class="drawer-bootom-button">
				<template v-if="examine">
					<a-button @click="onClose" style="margin-right: .8rem">取消</a-button>
					<template v-if="isPush">
						<a-button @click="reportPush" type="primary">推送</a-button>
					</template>
					<template v-else>
						<a-button @click="examineApprove(false)" type="danger">驳回</a-button>
						<a-button @click="examineApprove(true)" type="primary">同意</a-button>
					</template>
				</template>
				<template v-else-if="reading">
					<a-button @click="onClose" style="margin-right: .8rem">取消</a-button>
					<a-button @click="readReport" type="primary">批阅</a-button>
				</template>
				<template v-else>
					<a-button v-if="disabled" @click="onClose()" style="margin-right: .8rem">取消</a-button>
					<a-button v-else @click="confirmToClose()" style="margin-right: .8rem">取消</a-button>
					<a-button @click="handleSubmit(false)" type="primary">{{disabled ? '确定' : '保存'}}</a-button>
					<a-button v-if="!disabled" @click="handleSubmit(true)" type="primary">提交</a-button>
				</template>
			</div>
		</a-form>
	</a-drawer>
</template>

<script>
	import moment from 'moment';

	export default {
		name: 'monthlyWorkReport',
		props: {
			title: {
				type: String
			},
			visible: {
				type: Boolean,
				default: false
			}
		},
		components: {
		},
		data () {
			return {
				form : this.$form.createForm(this),
				formItemLayout: {
					labelCol: {
						span: 5
					},
					wrapperCol: {
						span: 19
					}
				},
				formItemLayoutWithOutLabel: {
					wrapperCol: {span: 19, offset: 5},
				},
				loading: false,
				id: null,
				status: null,
				workTaskDataArr: [],
				workRecordDataArr: [],
				user: {},
				disabled: false,
				examine: false,
				reading: false,
				comment: '',
				isPush: false,
				workSummary: '',
				isEditShow:true
			}
		},
		mounted () {
		},
		methods: {
			new () {
				this.$get('employee/currentEmp').then(res => {
					this.user = res.data;
				})
			},
			init({...item}, num) {
				//正文字号14px 二级表头给18排序  一级表头给22px
				//当num=2的时候编辑按钮及单元格不显示
				if(num == 2){
					this.isEditShow = false;
				}
				this.id = item.id
				this.disabled = item.disabled
				this.examine = item.examine
				this.reading = item.reading
				this.isPush = item.isPush
				this.$get('monthlyWorkReport/getOne', {id: this.id}).then(res=>{
					let data = res.data
					this.$get('employee/empByUserId',{userId: data.createUser}).then(r => {
						this.user = r.data;
					})
					this.status = data.status
					this.comment = data.comment
					this.workSummary = data.workSummary
					data.reportTime = moment(data.reportTime)
					this.workTaskDataArr = []
					for (let i = 0; i < data.workTaskList.length; i++) {
						this.workTaskDataArr.push(i)
					}

					this.workRecordDataArr = []
					for (let i = 0; i <data.workRecordList.length; i++) {
						let item = data.workRecordList[i]
						let recordList = JSON.parse(item.workRecord)
						while (recordList.length < 2) {
							recordList.push('')
						}
						let temp ={
							id: item.id,
							time: item.startTime && item.endTime ? [moment(item.startTime), moment(item.endTime)] : [],
							workRecordList : recordList,
							problem: item.problem,
							solution: item.solution,
							solve : item.solve == 1
						}
						this.workRecordDataArr.push(temp)
					}

					this.workTaskDataArr = data.workTaskList
					let fields = ['reportTime'];
					Object.keys(data).forEach((key) => {
						if(fields.indexOf(key) !== -1) {
							this.form.getFieldDecorator(key);
							let obj = {};
							obj[key] = data[key];
							this.form.setFieldsValue(obj);
						}
					})

				})
			},
			onClose() {
				this.id = null
				this.status = null
				this.disabled = false
				this.examine = false
				this.reading = false
				this.isPush = false
				this.workSummary = ''
				this.workTaskDataArr = []
				this.workRecordDataArr = []
				this.$emit('success')
				this.$emit('close', true)
			},
			confirmToClose () {
				let that = this
				that.$confirm({
					title: '确定取消编辑汇报?',
					content: '确定后未保存的汇报数据不会被保存',
					okText: '确定',
					okType: 'primary',
					cancelText: '取消',
					onOk() {
						that.onClose()
					},
					onCancel() {
					},
				});
			},
			removeRecordText(i,i2) {
				if (this.workRecordDataArr[i].workRecordList.length <= 2) {
					return;
				}
				this.workRecordDataArr[i].workRecordList.splice(i2,1)
			},
			addRecordText(i) {
				this.workRecordDataArr[i].workRecordList.push('')
			},
			removeWorkTask(k) {
				if (this.workTaskDataArr.length === 1) {
					return;
				}
				this.workTaskDataArr.splice(k, 1)
			},
			addWorkTask() {
				let temp ={
					currentMonthlyTask: '',
					nextMonthlyTask:''
				}
				this.workTaskDataArr = this.workTaskDataArr.concat(temp)
			},
			removeWorkRecord(k) {
				if (this.workRecordDataArr.length === 1) {
					return;
				}
				this.workRecordDataArr = this.workRecordDataArr.filter(key => key.id !== k)
			},
			addWorkRecord() {
				let temp = {
					workRecordList: ['',''],
					problem:'',
					solution:'',
					solve: false,
					time:[]
				}
				this.workRecordDataArr = this.workRecordDataArr.concat(temp)

			},
			readReport(){
				let data = {
					id: this.id,
					comment:this.comment,
				}

				this.$post('monthlyWorkReport/monthExamine', data).then(res => {
					this.$message.success("操作成功");
					this.$emit('success')
					this.onClose()
				})
			},
			examineApprove(examine){
				let data = {
					id: this.id,
					status: examine ? '2' : '3',
					comment:this.comment,
				}

				this.$post('monthlyWorkReport/examine', data).then(res => {
					this.$message.success("操作成功");
					this.$emit('success')
					this.onClose()
				})
			},
			handleSubmit(submit) {
				if (this.disabled) {
					this.onClose()
					return
				}
				let that = this
				if (submit) {
					that.$confirm({
						title: '确定提交汇报?',
						content: '请确认其中的时间和内容无误后，点击确定后提交',
						okText: '确定',
						okType: 'primary',
						cancelText: '取消',
						onOk () {
							that.submitDetail(submit)
						},
						onCancel () {
						},
					})
				} else {
					that.submitDetail(submit)
				}
			},
			submitDetail (submit) {
				let that = this;
				that.form.validateFields((err, values) => {
					if(!err) {
						const {workRecordDataArr} = that;
						let workRecordListData = []
						for (let i = 0; i < workRecordDataArr.length; i++) {
							let item = workRecordDataArr[i]

							let startTime = item.time[0] ? item.time[0].format('YYYY-MM-DD') :null
							let endTime = item.time[1] ? item.time[1].format('YYYY-MM-DD') :null
							let workRecordList = item.workRecordList
							let tempRecord = []
							for (let j = 0; j < workRecordList.length; j++) {
								if (workRecordList[j]) {
									tempRecord.push(workRecordList[j])
								}
							}
							let workRecord = JSON.stringify(tempRecord)
							let temp = {
								weekOfMonth: i+1,
								startTimeStr: startTime,
								endTimeStr: endTime,
								workRecord: workRecord,
								problem: item.problem,
								solution: item.solution,
								solve: item.solve ? 1:0
							}
							workRecordListData.push(temp)
						}

						let data = {
							...values,
							id: that.id,
							status: that.status,
							workSummary: that.workSummary,
							workRecordListStr: JSON.stringify(workRecordListData)
						}
						if (submit) {
							data.status = '1'
						}
						if (that.workTaskDataArr.length > 0) {
							let workTaskList = that.workTaskDataArr.filter(i => i.currentMonthlyTask || i.nextMonthlyTask)
							data.workTaskListStr = JSON.stringify(workTaskList)
						}
						data.reportTimeStr =data.reportTime.format('YYYY-MM-DD HH:mm:ss')
						// data.startTimeStr =data.startTime.format('YYYY-MM-DD')
						// data.endTimeStr =data.endTime.format('YYYY-MM-DD')
						delete data.workTaskList
						delete data.reportTime
						// delete data.startTime
						// delete data.endTime
						let requestUrl = that.id ? 'monthlyWorkReport/change' : 'monthlyWorkReport/add';
						that.$post(requestUrl, data).then(r => {
							that.loading = false
							that.$emit('success')
							that.$message.success('操作成功');
							that.onClose()
						}).catch( e => {
							that.loading = false
						})
					}
				});
			},
			reportPush () {
				this.$post('monthlyWorkReport/push/' + this.id,{}).then(res => {
					this.$message.success("操作成功");
					this.$emit('success')
					this.onClose()
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	/deep/ .card-edit-img-size img{
		width:100%;
	}
	/deep/ .ant-upload.ant-upload-select-picture-card{
		width:100%;
	}
	/deep/ .ant-input,.ant-input:hover{
		border: 0 ;
		margin: 0;
	}
	/deep/ .ant-form-item,.ant-row{
		width: 100%;
		padding: 0;
		margin: 0;
	}
	/deep/ .ant-form-item-control-wrapper{
		width: 100% !important;
		padding: 0;
		margin: 0;
	}
	/deep/ .ant-input-disabled{
		background: none;
		color: #666;
	}
	.recordText{
		box-sizing: border-box;
		border-bottom: 1px #ccc solid;
	}
	.recordText:last-child{
		border-bottom:none;
	}
	.taskItemBox{
		border: 1px #ccc solid;
		border-top: none;
		display: flex;
		align-items: center;
		height: 85px;
		div{
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.boxLabel, .boxLabelOne{
			line-height: 52px;
		}
	}
	.boxLabel{
		border-left: 1px #ccc solid;
	}
	.boxLabel, .boxLabelOne{
		border-right: 1px #ccc solid;
		text-align: center;
		height: 100%;
	}
	.firstLevelMeter{
		font-size: 22px;
		font-weight: bold;
	}
	.secondaryHeader{
		font-size: 18px;
		font-weight: bold;
	}
	.btnBox{
		height: 65px;
		border: 1px #ccc solid;
		display: flex;
		border-top: none;
		justify-content: center;

	}
	.workSummaryBox{
		margin-bottom: 30px;
	}
	.commentTitleBox{
		background: #3db389;
		border: 1px #ccc solid;
		line-height: 60px;
		text-align: center;
		color: #fff;
	}
	.commentBox {
		border: 1px #ccc solid;
		border-top: none;
		margin-bottom: 30px;
	}
	.recordItemBox,.recordSubTitleBox,.task,.recordTitleBox,.workSummaryTitleBox, .workSummaryBox{
		border: 1px #ccc solid;
		border-top: none;
	}
	.recordItemBox>div>div>div>div>div,.recordItemBox>div>div>div{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.recordSubTitleBox{
		line-height: 40px;
		background: #f5f5f5;
		text-align: center;
	}
	.task, .recordTitleBox, .workSummaryTitleBox{
		background: #f5f5f5;
		line-height: 65px;
		text-align: center;
	}
	.task{
		div {
			padding: 0 15px;
		}
		.boxLabel{
			border-left: 1px #ccc solid;
			border-right: 1px #ccc solid;
		}
		.boxLabelOne{
			border-right: 1px #ccc solid;
		}
	}
	.titleBox{
		width: 100%;
		border: 1px solid #ccc;
		line-height: 65px;
		.boxLabel{
			text-align: center;
			background: #3db389;
			color: #fff;
			border-right: 1px #ccc solid;
		}
		div{
			padding: 0 15px;
		}
		ul {
			padding: 0;
			margin: 0;
			width: 100%;
			display: flex;
			list-style: none;
			height: 65px;
			justify-content: space-between;
			li{
				display: flex;
				align-items: center;
				border-left: 1px #ccc solid;
				div{
					display: inline-block;
					line-height: 40px;
					padding: 0 15px;
					vertical-align: middle;
				}
				div:first-child{
					background: #3db389;
					color: #fff;
					border-right: 1px #ccc solid;
				}
			}
			li:first-child{
				border-left: none;
			}

		}
	}
	/*.card-edit-img-size .ant-form-item-children{*/
	/*	display:flex;*/
	/*}*/
</style>



// WEBPACK FOOTER //
// src/views/OA/monthlyWorkReportList/monthlyWorkReport.vue